import { APPEND_ZOHO_INVOICES, SET_INVOICE_LINK_IS_LOADING, SET_ZOHO_INVOICES, SET_INVOICES_IS_LOADING, SET_INVOICES_IS_NOT_FOUND, SET_ZOHO_INVOICES_TOTAL_LENGTH, SET_SHOW_SKELETON_INVOICES } from '../../actionTypes/zohoInvoice'

const initialState = {
	invoices: [],
	invoicesTotalLength: 0,
	invoicesIsLoading: false,
	invoiceLinkIsLoading: false,
	invoicesIsNotFound: false,
	showSkeletonInvoices: false
}

export function zohoInvoiceReducer (state = initialState, action) {
	switch (action.type) {
		case SET_ZOHO_INVOICES:
			return {
				...state,
				invoices: action.value,
			}
		case APPEND_ZOHO_INVOICES:
			return {
				...state,
				invoices: state.invoices.concat(...action.value),
			}
		case SET_ZOHO_INVOICES_TOTAL_LENGTH:
			return {
				...state,
				invoicesTotalLength: action.value,
			}
		case SET_INVOICES_IS_LOADING:
			return {
				...state,
				invoicesIsLoading: action.value,
			}
		case SET_INVOICE_LINK_IS_LOADING:
			return {
				...state,
				invoiceLinkIsLoading: action.value,
			}
		case SET_INVOICES_IS_NOT_FOUND:
			return {
				...state,
				invoicesIsNotFound: action.value,
			}
		case SET_SHOW_SKELETON_INVOICES:
			return {
				...state,
				showSkeletonInvoices: action.value,
			}
		default:
			return state
	}
}
